"use strict";

exports.__esModule = true;
exports.default = jsonToFasta;

var _veSequenceUtils = require("ve-sequence-utils");

function jsonToFasta(jsonSequence, options) {
  var cleanedData = (0, _veSequenceUtils.tidyUpSequenceData)(jsonSequence);
  var name = cleanedData.name,
      circular = cleanedData.circular,
      description = cleanedData.description,
      size = cleanedData.size,
      sequence = cleanedData.sequence,
      isProtein = cleanedData.isProtein,
      proteinSize = cleanedData.proteinSize,
      proteinSequence = cleanedData.proteinSequence;


  options = options || {};
  var seqToUse = sequence;
  var sizeToUse = size;
  if (isProtein && proteinSequence) {
    seqToUse = proteinSequence;
    sizeToUse = proteinSize;
  }
  // options.reformatSeqName = options.reformatSeqName === false ? false : true;
  var fastaString = "";
  fastaString += ">" + (name || "Untitled Sequence") + "|";
  fastaString += "|" + sizeToUse;
  fastaString += description ? "|" + description : "";
  fastaString += "|" + (circular ? "circular" : "linear");
  fastaString += "\n";
  fastaString += (seqToUse.match(/.{1,80}/g) || []).join("\n");
  return fastaString;
}
module.exports = exports["default"];